__turbopack_context__.v({
  "active": "Header-module-scss-module__xy0aOG__active",
  "cart-button": "Header-module-scss-module__xy0aOG__cart-button",
  "cart-item-number": "Header-module-scss-module__xy0aOG__cart-item-number",
  "close-icon": "Header-module-scss-module__xy0aOG__close-icon",
  "consultant-card": "Header-module-scss-module__xy0aOG__consultant-card",
  "consultant-card-body": "Header-module-scss-module__xy0aOG__consultant-card-body",
  "consultant-card-header": "Header-module-scss-module__xy0aOG__consultant-card-header",
  "consultant-image": "Header-module-scss-module__xy0aOG__consultant-image",
  "consultant-name": "Header-module-scss-module__xy0aOG__consultant-name",
  "consultant-wrapper": "Header-module-scss-module__xy0aOG__consultant-wrapper",
  "container-bottom": "Header-module-scss-module__xy0aOG__container-bottom",
  "container-top": "Header-module-scss-module__xy0aOG__container-top",
  "desktop": "Header-module-scss-module__xy0aOG__desktop",
  "header": "Header-module-scss-module__xy0aOG__header",
  "header-bottom": "Header-module-scss-module__xy0aOG__header-bottom",
  "header-top": "Header-module-scss-module__xy0aOG__header-top",
  "logo": "Header-module-scss-module__xy0aOG__logo",
  "logo-wrapper": "Header-module-scss-module__xy0aOG__logo-wrapper",
  "mobile": "Header-module-scss-module__xy0aOG__mobile",
  "mobile-button": "Header-module-scss-module__xy0aOG__mobile-button",
  "mobile-search-container": "Header-module-scss-module__xy0aOG__mobile-search-container",
  "navigation": "Header-module-scss-module__xy0aOG__navigation",
  "search-container": "Header-module-scss-module__xy0aOG__search-container",
});
